import RichTextField from 'Components/ComponentLibrary/Molecules/RichTextField';
import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import { TaxDiagnosticNoteHistory } from './TaxDiagnosticNoteHistory';

export const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();

  return (
    <FDStack direction={'column'} spacing={2} width={360} {...dataAttrs('tax-diagnostic-notes')}>
      <RichTextField
        value={resource.attr('content')}
        onChange={(val) => {
          resource.attr('content', val);
        }}
        rounded
        inputMinHeight={400}
      />
      <FDPrimaryActionButton
        label={'Save note'}
        onClick={onSubmit}
        loading={saving}
        {...dataAttrs('tax-diagnostic-notes-save-btn')}
      />
      {resource.withRelationship(fr.relationships.noteHistory.name, (rel) => {
        return (
          <TaxDiagnosticNoteHistory relationship={rel} />
        );
      }, () => null)}
    </FDStack>
  );
};
